import { useState } from "react";
import Chip from "../components/Chip";
import Footer from '../components/Footer'
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context";

export const Blog = () => {
  const navigate = useNavigate();
  const { blogPosts } = useAppContext();

  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");

  const cats = ["All", "Recipes", "Culture", "Health", "Beverages", "News", "Community"];
  console.log("blogPosts from API:", blogPosts.map(b => ({ id: b.id, title: b.title, status: b.status })));

  const filtered = blogPosts
    .filter(b => b.status === "Published")
    .filter(b => (cat === "All" || b.cat === cat) && (b.title.toLowerCase().includes(q.toLowerCase()) || !q));

  const catColors = {
    Recipes: "bg-orange-100 text-orange-600", Culture: "bg-blue-100 text-blue-600",
    Health: "bg-green-100 text-green-600", Beverages: "bg-amber-100 text-amber-700",
    News: "bg-purple-100 text-purple-600", Community: "bg-pink-100 text-pink-600",
  };

  return (
    <>
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="text-center mb-12">
          <p className="text-sm font-bold text-[#f97316] uppercase tracking-wider mb-2">Our Blog</p>
          <h1 className="font-serif text-5xl text-gray-900 mb-3">Stories, Recipes & <span className="text-[#f97316]">Culture</span></h1>
          <p className="text-gray-400 max-w-lg mx-auto">Dive deep into South Indian cuisine, culture, health and the stories behind our food.</p>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-8 justify-between">
          <div className="flex gap-2 flex-wrap">
            {cats.map(c => <Chip key={c} active={cat === c} onClick={() => setCat(c)}>{c}</Chip>)}
          </div>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">🔍</span>
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search articles..." className="pl-9 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm bg-white w-56" />
          </div>
        </div>

        {/* Featured */}
        {!q && cat === "All" && filtered.filter(b => b.hot).length > 0 && (
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {filtered.filter(b => b.hot).map(b => (
              <button key={b.id} onClick={() => navigate(`/blog/${b.id}`)} className="relative rounded-3xl overflow-hidden group text-left h-80 img-zoom block w-full">
                <img src={b.img} alt={b.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute top-4 left-4"><span className={`text-xs font-bold px-3 py-1.5 rounded-full ${catColors[b.cat] || "bg-white text-gray-700"}`}>{b.cat}</span></div>
                <div className="absolute bottom-0 p-6 text-white">
                  <h2 className="font-serif text-xl font-black mb-2 leading-tight group-hover:text-[#f97316] transition-colors">{b.title}</h2>
                  <p className="text-sm text-gray-300 lc2 mb-3">{b.excerpt}</p>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <span>✍️ {b.author}</span><span>·</span><span>⏱ {b.read || b.read_time} read</span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        )}

        {filtered.length === 0 && (
          <div className="text-center py-20 text-gray-400">No posts found.</div>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filtered.map(b => (
            <button key={b.id} onClick={() => navigate(`/blog/${b.id}`)} className="bg-white rounded-3xl overflow-hidden border border-gray-100 card-hover group text-left img-zoom block w-full">
              <div className="overflow-hidden">
                {b.img
                  ? <img src={b.img} alt={b.title} className="w-full h-48 object-cover" />
                  : <div className="w-full h-48 bg-orange-50 flex items-center justify-center text-4xl">📝</div>
                }
              </div>
              <div className="p-5">
                <span className={`text-[10px] font-bold px-2.5 py-1 rounded-full ${catColors[b.cat] || "bg-gray-100 text-gray-600"}`}>{b.cat}</span>
                <h3 className="font-bold text-gray-900 mt-3 mb-2 leading-snug group-hover:text-[#f97316] transition-colors">{b.title}</h3>
                <p className="text-xs text-gray-400 lc3 leading-relaxed mb-4">{b.excerpt}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <div className="w-5 h-5 bg-gradient-to-br from-[#f97316] to-red-500 rounded-lg flex items-center justify-center text-white text-[8px] font-black">
                      {(b.author || "?").split(" ").map(w => w[0]).join("")}
                    </div>
                    <span>{b.author}</span>
                  </div>
                  <span className="text-xs text-gray-300">{b.read || b.read_time} read</span>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#f97316] to-red-500 rounded-3xl p-10 text-white text-center">
          <h3 className="font-serif text-3xl mb-3">Never Miss a Recipe 📧</h3>
          <p className="text-orange-100 mb-6">Weekly South Indian recipes, food stories and exclusive discounts.</p>
          <div className="flex gap-3 max-w-md mx-auto">
            <input placeholder="your@email.com" className="flex-1 px-4 py-3 rounded-xl bg-white/20 text-white placeholder-orange-200 border border-white/30 text-sm focus:outline-none focus:border-white" />
            <button className="bg-white text-[#f97316] font-black px-6 py-3 rounded-xl hover:scale-105 transition-transform btn-press flex-shrink-0">Subscribe</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
